const langArray = [
  { code: 'EN', name: 'English' },
  // { code: 'RU', name: 'Russian' },
  // { code: 'DE', name: 'Deutsch' },
  { code: 'LT', name: 'Lithuanian' },
  { code: 'ES', name: 'Spanish' },
  { code: 'SV', name: 'Swedish' },
  // { code: 'IT', name: 'Italian' },
];

export default langArray;
